import {withTranslation} from "react-i18next";
import React from "react";
import Icon from "../../Icon";

interface HeaderBackBtnProps {
  text?: string;
  hideText?: boolean;
  handleBackButtonClick: () => void;
  setLoading?: () => void;
  t: (key: string) => string;
}

const HeaderBackBtn = ({handleBackButtonClick, setLoading, t, hideText, text}: HeaderBackBtnProps) => {
  return (
    <button
      className="header-back-btn flex items-center"
      aria-label={t("BACK")}
      title={t("BACK")}
      onClick={() => {
        setLoading && setLoading();
        handleBackButtonClick();
      }}
    >
      <span className="flex mr-2">
        <Icon name="arrow-left" tooltip={t("BACK")} iconSize="20px" />
      </span>
      {(!hideText && text) || t("BACK")}
    </button>
  );
};

const HeaderBackBtnWithTranslation = withTranslation()(HeaderBackBtn);
export default HeaderBackBtnWithTranslation;
